<template>
  <div>
    <div
      v-if="remainingCredits > 0"
      class="columns"
    >
      <div class="column" />
      <div class="column is-6">
        <div class="app-block p-b-lg p-t-md p-r-lg">
          <div class="heading-line title is-4 has-text-weight-light m-l-lg">
            <span>Avoirs</span>
          </div>
          <div class="title is-5 has-text-weight-light has-text-centered">
            {{ $t('offers.cart.credit') }} <strong class="has-text-weight-bold">{{ remainingCredits }} €</strong>
          </div>
          <div class="columns">
            <div class="column is-1" />
            <div class="column is-10 ">
              <b-field :label="$t('offers.cart.credit_field')">
                <b-numberinput
                  v-model="credit"
                  name="credit"
                  min="0"
                  :max="creditMax"
                />
              </b-field>
            </div>
            <div class="column" />
          </div>
        </div>
      </div>
      <div class="column" />
    </div>

    <div
      v-if="discountCredits.length > 0"
      class="columns"
    >
      <div class="column" />
      <div class="column is-6">
        <div class="app-block p-b-lg p-t-md p-r-lg">
          <div class="heading-line title is-4 has-text-weight-light m-l-lg">
            <span>Réductions</span>
          </div>
          <div class="p-l-md">
            <div
              v-if="discountCredits.length > 1"
              class="subtitle"
            >
              Vous disposez des réductions suivantes:
            </div>
            <div
              v-else
              class="subtitle"
            >
              Vous disposez de la réduction suivante:
            </div>
            <div
              v-for="discount in discountCredits"
              class="p-b-md"
            >
              <b-checkbox
                v-model="selectedDiscount"
                :native-value="discount"
              >
                Réduction de <strong>{{ discount.amount }} €</strong> valable du
                <strong>{{ formatDate(discount.validity_start) }}</strong>
                au <strong>{{ formatDate(discount.validity_end) }}</strong>
              </b-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="column" />
    </div>
    <div class="columns">
      <div class="column" />
      <div class="column is-6">
        <div
          v-if="pendingOrder"
          class="app-block p-b-lg p-t-md p-r-lg"
        >
          <div class="heading-line title is-4 has-text-weight-light m-l-lg">
            <span>Code bourse</span>
          </div>
          <div class="p-l-md">
            <div v-if="!pendingOrder.promoCodes.length">
              <div>
                <input
                  v-model="promoCode"
                  class="input input-code"
                  type="text"
                  placeholder="Code bourse"
                >
                <a
                  class="button has-text-success"
                  style="cursor: pointer"
                  :class="[!promoCode ? 'app-disabled':'']"
                  @click="setPromo(promoCode)"
                >
                  Valider
                </a>
              </div>
              <transition name="slide-fade">
                <div class="has-text-danger has-text-centered">
                  {{ errorPromoMsg }}
                </div>
              </transition>
            </div>
            <div v-else>
              <div>
                <span class="input-code"><i>Code bourse:</i> <strong>{{ pendingOrder.promoCodes[0].code }}</strong>
                  <span v-if="pendingOrder.promoCodes[0].valueType === 'amount'">
                    (-{{ pendingOrder.promoCodes[0].value }}€)
                  </span>
                  <span v-else-if="pendingOrder.promoCodes[0].valueType === 'percentage'">
                    (-{{ pendingOrder.promoCodes[0].value }}%)
                  </span>
                </span>
                <a
                  class="button has-text-warning delete-code"
                  style="cursor: pointer"
                  @click="removePromo(pendingOrder.promoCodes[0])"
                >
                  <strong>Supprimer</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column" />
    </div>

    <div class="section">
      <div class="has-background-white-ter p-md has-text-centered">
        <b-checkbox v-model="checkboxCGE">
          <strong>
            J'accepte les
            <a
              :href="'/cgv/' + schoolType"
              target="_blank"
              title="Conditions générales de vente"
            >
              {{ $t('shop.messages.documents.cgv') }}
            </a>
          </strong>
        </b-checkbox>
      </div>
    </div>

    <div :class="[!checkboxCGE && !checkboxContract ? 'app-disabled':'']">
      <div
        v-if="orderTotalCheckout > 0"
        class="columns has-text-centered"
      >
        <div
          v-if="!isSchoolingOrder && !isSchoolingCheckedOutOrder(order)"
          class="column is-3"
        >
          <button
            type="submit"
            class="app-block payment-button p-t-md"
            @click="toggleCB"
          >
            <div class="is-size-6 has-text-grey is-italic">
              Carte Bancaire
            </div>
            <br>
            <div class="is-flex is-horizontal-center ">
              <figure class="image is-48x48">
                <img src="/img/icons/cards.png">
              </figure>
            </div>
          </button>
        </div>
        <div
          v-else
          class="column is-2"
        />

        <div class="column is-3">
          <button
            type="submit"
            class="app-block payment-button p-t-md"
            @click="toggleCheck"
          >
            <div class="is-size-6 has-text-grey is-italic">
              Chèque(s)
            </div>
            <div class="is-flex is-horizontal-center ">
              <figure class="image is-64x64  ">
                <img src="/img/icons/check.png">
              </figure>
            </div>
          </button>
        </div>

        <!--<div class="column" v-if="isSchoolingOrder || isSchoolingCheckedOutOrder(order)">
                    <button @click="toggleDebit" type="submit"
                            class="app-block payment-button p-t-lg">
                        <div class="is-size-6 has-text-grey is-italic">Prélèvement(s)</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64  ">
                                <img src="/img/icons/bank-debit.png">
                            </figure>
                        </div>
                    </button>
                </div>-->


        <div class="column is-3">
          <button
            type="submit"
            class="app-block payment-button p-t-md"
            @click="toggleTransfert"
          >
            <div class="is-size-6 has-text-grey is-italic">
              Virement
            </div>
            <br>
            <div class="is-flex is-horizontal-center ">
              <figure class="image is-64x64">
                <i
                  class="fa fa-exchange fa-5x"
                  aria-hidden="true"
                />
              </figure>
            </div>
          </button>
        </div>

        <div class="column is-3">
          <button
              type="submit"
              class="app-block payment-button p-t-md"
              @click="toggleOrga"
          >
            <div class="is-size-6 has-text-grey is-italic">
              Organisme de financement
            </div>
            <br>
            <div class="is-flex is-horizontal-center ">
              <figure class="image is-64x64">
                <i
                    class="fa fa-institution fa-5x"
                    aria-hidden="true"
                />
              </figure>
            </div>
          </button>
        </div>

        <!--<div class="column">
                    <button @click="toggleNote" type="submit"
                            class="app-block payment-button p-t-lg">
                        <div class="is-size-6 has-text-grey is-italic">Espèces</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64  ">
                                <img src="/img/icons/bank-note.png">
                            </figure>
                        </div>
                    </button>
                </div>-->
      </div>
      <div v-else>
        <div v-if="pendingOrder.promoCodes.length">
          <div class="has-text-centered m-b-lg">
            <button
              :class="'button button-save ' + isLoading"
              @click="sendWithPromo"
            >
              Je règle avec un code bourse
            </button>
          </div>
        </div>
        <div v-else>
          <div class="has-text-centered m-b-lg">
            <button
              :class="'button button-save ' + isLoading"
              @click="sendWithCredit"
            >
              Je règle en avoir
            </button>
          </div>
        </div>
      </div>


      <div id="payment-validation">
        <transition
          name="component-fade"
          mode="out-in"
        >
          <component
            :is="paymentView"
            :school="school"
            :total-checkout="orderTotalCheckout"
            :total-schooling-checkout="orderTotalSchoolingCheckout"
            :candidate="candidate"
            :candidates="candidates"
            :guarantor="guarantor"
            :credit="credit"
            :discount="selectedDiscount"
            @send="savePayment"
            @edit="editPayment"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import BankOfpView from './OrderOfp.vue'
    import OrderCBView from './OrderCB.vue'
    import OrderSimpleOfpView from './OrderSimpleOfp'
    import OrderDebitNoOfpView from './OrderDebitNoOfp'
    import BankDirectDebitView from './OrderDirectDebit.vue'
    import BankTransferView from './OrderTransfer.vue'
    import BankNoteView from './OrderNote.vue'
    import api from 'services/offers'
    import OrgaView from "./OrderOrga.vue";

    export default {
        props: {
            order: { type: Object },
            school: { type: Object },
            candidate: {type: Object},
            candidates: {type: Array}
        },
        data() {
            return {
                paymentView: '',
                checkboxContract: false,
                checkboxCGE: false,
                guarantor: null,
                selectedDiscount: [],
                usedCredit: 0,
                credit: 0,
                isLoading: '',
                promoCode: null,
                errorMsg: null,
                errorPromoMsg: '',
                pendingOrder: null
            }
        },
        computed: {
            ...mapGetters({
                account: 'auth/getAccount',
                statusPromo: 'candidate/getStatus',
                statusPromoMessage: 'candidate/getMessage',
            }),
            ...mapGetters(
                'orders', [
                    'totalCheckout',
                    'totalSchoolingCheckout',
                    'isSchoolingOrder',
                    'isSchoolingOfferOrder',
                    'isOfferOrder',
                    'selectedOrder',
                    'orderRef',
                    'isSchoolingCheckedOutOrder',
                    'isSchoolingOfferCheckedOutOrder',
                    'isOfferCheckedOutOrder',
                    'status',
                    'statusMessage'
                ]
            ),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),

            schoolType() {
              if (this.school) {
                  return this.school.type
              }
            },

          orderTotalCheckout() {
            let total = 0;

            if (this.order && this.order.payment_total) {
              total = Number(parseFloat(this.order.payment_total).toFixed(2));
            } else {
              total = this.totalCheckout;
            }

            if (this.credit <= this.remainingCredits) {
              total -= this.credit;
            }

            if (this.selectedDiscount.length) {
              let totalDiscount = 0;
              this.selectedDiscount.map(function (credit) {
                totalDiscount += parseInt(credit.amount);
              });
              total -= totalDiscount;
            }

            const applyPromo = (promoCodes) => {
              if (promoCodes.length) {
                const promo = promoCodes[0];
                const eligibleItemsTotal = this.pendingOrder.choices.reduce((acc, choice) => {
                  choice.choices.forEach(item => {
                    if (this.isItemEligibleForPromo(item, promo)) {
                      acc += parseFloat(item.price);
                    }
                  });
                  return acc;
                }, 0);

                if (promo.valueType === 'amount') {
                  total -= Math.min(parseInt(promo.value), eligibleItemsTotal);
                } else if (promo.valueType === 'percentage') {
                  total -= (eligibleItemsTotal * parseFloat(promo.value)) / 100;
                }
              }
            };

            if (this.pendingOrder) {
              applyPromo(this.pendingOrder.promoCodes);
            }

            if (this.order) {
              applyPromo(this.order.promoCodes);
            }

            return total + this.usedCredit > 0 ? total + this.usedCredit : 0;
          },
          orderTotalSchoolingCheckout() {
                let total = this.totalSchoolingCheckout

                if (this.credit <= this.remainingCredits) {
                    return total - this.credit
                }

                if (this.order && this.order.credits) {
                    this.order.credits.map(function (credit) {
                        if (credit.type.code === 'credit') {
                            total += parseInt(credit.amount)
                        }
                    }, this)
                }

                if (this.selectedDiscount.length) {
                    this.selectedDiscount.map(function (credit) {
                        total += parseInt(credit.amount)
                    })
                }
                return total
            },
            remainingCredits() {
                if (this.usedCredit > 0) {
                    return this.account.remainingCredits + this.usedCredit
                }else{
                    return this.account.remainingCredits
                }

            },
            totalPaiement() {
                let total = this.orderTotalCheckout - this.orderTotalSchoolingCheckout
                let totalSchooling = this.totalSchoolingCheckout
                /*if (this.cartDiscount()) {
                    totalSchooling = Math.ceil(totalSchooling - (totalSchooling * 0.05))
                }*/
                return total + totalSchooling
            },
            creditMax() {
                if (this.remainingCredits <= this.totalPaiement) {
                    return this.remainingCredits
                }else{
                    return this.totalPaiement
                }
            },
            discountCredits() {

                let credits = []
                if (this.account && this.account.discountCredits) {
                    this.account.discountCredits.map(function (credit) {
                        if ((this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'schooling')) {
                            credits.push(credit)
                        }
                        if ((this.isSchoolingOfferOrder || this.isSchoolingOfferCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'schooling_offer')) {
                            credits.push(credit)
                        }
                        if ((this.isOfferOrder || this.isOfferCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'offer')) {
                            credits.push(credit)
                        }
                    }, this)
                }
                return credits
            },
        },
        methods: {
            ...mapActions({
                refreshAccount: 'auth/setAccount',
                setOrderPromo: 'candidate/setOrderPromo',
                removeOrderPromo: 'candidate/removeOrderPromo',
            }),
            ...mapActions(
                'orders', [
                    'fetchCBCheckout',
                    'orderCheckout'
                ]
            ),
            formatDate(date) {
                return moment(date, 'YYYY-MM-DD hh:mm:ss').format('L')
            },
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
          isItemEligibleForPromo(item, promo) {
            return promo.pivot && promo.pivot.item_id === item.id;
          },
            removePromo: function(promo) {
                promo.order_id = this.order ? this.order.id:this.orderRef
                this.removeOrderPromo(promo).then(() => {
                    if (this.statusPromo === 200) {
                        this.paymentView = '';
                        if (this.orderRef) {
                            api.getOrder(this.orderRef).then((result) => {
                                this.pendingOrder = result.data
                            }).catch(e => {
                            })
                        }
                    } else {
                        this.errorPromoMsg = this.statusPromoMessage
                        setTimeout(() => {
                            this.errorPromoMsg = ''
                        }, 2000)
                    }
                }).catch(() => {
                    this.errorPromoMsg = this.statusPromoMessage
                    setTimeout(() => {
                        this.errorPromoMsg = ''
                    }, 2000)
                })
            },
            setPromo: function (code) {
                let promoCode = {}
                promoCode.order = this.order ? this.order.id:this.orderRef
                promoCode.code = code
                this.setOrderPromo(promoCode).then(() => {
                    if (this.statusPromo === 200) {
                        this.paymentView = '';
                        if (this.orderRef) {
                            api.getOrder(this.orderRef).then((result) => {
                                this.pendingOrder = result.data
                            }).catch(e => {
                            })
                        }
                    } else {
                        this.errorPromoMsg = this.statusPromoMessage
                        setTimeout(() => {
                            this.errorPromoMsg = ''
                        }, 2000)
                    }
                }).catch(() => {
                    this.errorPromoMsg = this.statusPromoMessage
                    setTimeout(() => {
                        this.errorPromoMsg = ''
                    }, 2000)
                })
            },
            sendWithPromo: function () {
                this.toggleLoading()
                const order = {}
                order.id = this.order ? this.order.id:this.orderRef
                order.cart = this.cartChoices
                order.credit = this.credit
                order.discount = this.selectedDiscount
                order.guarantor = this.guarantor
                order.order_date = new Date()
                order.payment_mode = 'PROMO'
                order.payment_total = this.orderTotalCheckout
                order.payment_currency = this.paymentCurrency
                order.payment_number = 1
                order.payments = [ {
                    'date': new Date(),
                    'amount': this.orderTotalCheckout,
                    'number': 1
                } ]
                this.orderCheckout(order).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.savePayment()
                    } else {
                        this.toggleLoading()
                      if (this.statusMessage) {
                        this.errorMsg = this.statusMessage
                      }else{
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                      }
                    }
                }).catch(() => {
                    this.toggleLoading()
                  if (this.statusMessage) {
                    this.errorMsg = this.statusMessage
                  }else{
                    this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                  }
                })
            },
            sendWithCredit: function () {
                this.toggleLoading()
                const order = {}
                order.id = this.order ? this.order.id:this.orderRef
                order.cart = this.cartChoices
                order.credit = this.credit
                order.discount = this.selectedDiscount
                order.guarantor = this.guarantor
                order.order_date = new Date()
                order.payment_mode = 'CREDIT'
                order.payment_total = this.orderTotalCheckout
                order.payment_currency = this.paymentCurrency
                order.payment_number = 1
                order.payments = [ {
                    'date': new Date(),
                    'amount': this.orderTotalCheckout,
                    'number': 1
                } ]
                this.orderCheckout(order).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.savePayment()
                    } else {
                        this.toggleLoading()
                      if (this.messages) {
                        this.errorMsg = this.messages
                      }else{
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                      }

                    }
                }).catch(() => {
                    this.toggleLoading()
                  if (this.messages) {
                    this.errorMsg = this.messages
                  }else{
                    this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                  }
                })
            },
            toggleCB () {
                this.errorShow = false
                let order = {
                    order_id: this.orderRef,
                    credit: this.credit
                }
                this.fetchCBCheckout(order).then((result) => {
                    this.paymentView = OrderCBView
                    this.$scrollTo('#payment-validation', {offset: -250}, 500)
                }).catch((err) => {

                    this.error = err.message
                })
            },
            toggleCheck() {
                this.errorShow = false
                if (this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) {
                    this.paymentView = BankOfpView
                }else{
                    this.paymentView = OrderSimpleOfpView
                }

                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            toggleTransfert() {
                this.errorShow = false
                this.paymentView = BankTransferView
                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
          toggleOrga() {
            this.errorShow = false;
            this.paymentView = OrgaView;
            this.$scrollTo('#payment-validation', {offset: -250}, 500)
          },
            toggleDebit() {
                this.errorShow = false
                if (this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) {
                    this.paymentView = BankDirectDebitView
                }else{
                    this.paymentView = OrderDebitNoOfpView
                }

                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            toggleNote() {
                this.errorShow = false
                this.paymentView = BankNoteView
                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            savePayment() {
                this.refreshAccount()
                this.$emit('send')
            },
            editPayment() {
                this.$emit('edit')
            },
        },
        created() {

            if (this.orderRef) {
                api.getOrder(this.orderRef).then((result) => {
                    this.pendingOrder = result.data
                }).catch(e => {
                })
            }

            if (this.order && this.order.credits) {
                this.order.credits.map(function (credit) {
                    if (credit.type.code === 'credit') {
                        this.credit += parseInt(credit.amount)
                        this.usedCredit += parseInt(credit.amount)
                    }
                }, this)

                this.order.credits.map(function (credit) {
                    if (credit.type.code === 'discount' && this.account.discountCredits) {
                        let selected = credit.credit_id
                        this.account.discountCredits.map(function (credit) {
                            if (credit.id === selected) {
                                this.selectedDiscount.push(credit)
                            }
                        }, this)

                    }
                }, this)
            }
        }
    }
</script>

<style scoped>
    .delete-code {
        margin-top: -6px;
    }
    .input-code {
        width: 50%;
        padding: 0.75rem;
    }
</style>
